document.documentElement.classList.remove('no-js');

document.addEventListener('DOMContentLoaded', () => {
  const menuButton = document.querySelector('[data-mobile-menu-button]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
      if (menuButton && mobileMenu) {
          menuButton.addEventListener('click', () => {
                const open = menuButton.getAttribute('aria-expanded') === 'true';
                      menuButton.setAttribute('aria-expanded', String(!open));
                            mobileMenu.hidden = open;
                                });
                                  }

                                  document.querySelectorAll('[data-product-section]').forEach((section) => {
                                    const select = section.querySelector('[data-variant-select]');
                                    const priceBox = section.querySelector('[data-product-price]');
                                    if (select && priceBox) {
                                    select.addEventListener('change', () => {
                                    const option = select.options[select.selectedIndex];
                                    const compare = option.dataset.comparePrice;
                                    const price = option.dataset.price;
                                    priceBox.innerHTML = `<div class="price${compare && compare !== price ? ' price--sale' : ''}">${compare && compare !== price ? `<s>${compare}</s>` : ''}<span>${price}</span></div>`;
                                    });
                                  }
                                    const thumbs = section.querySelectorAll('.product-thumb');
                                    if (thumbs.length) {
                                    thumbs.forEach((thumb) => {
                                    thumb.addEventListener('click', () => {
                                    const idx = thumb.dataset.mediaIndex;
                                    section.querySelectorAll('.product-gallery__hero .product-media').forEach((media) => {
                                    media.classList.toggle('is-active', media.dataset.mediaIndex === idx);
                                    });
                                    thumbs.forEach((t) => t.classList.toggle('is-active', t === thumb));

                                  });
                                });
                                }
                                });
                                });